export default __webpack_public_path__ + "static/media/2.86b97ddd.jpg";